import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[float]',
    standalone: false
})
export class FloatingPlaceholderDirective implements AfterViewInit {

  @Input() placeholder = '';

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }


  ngAfterViewInit(): void {
    const input = this.elementRef.nativeElement as HTMLInputElement;
    const isDate = input.type === 'date';

    if(isDate){
      input.type = 'text';
      input.onfocus = () => {input.type = 'date'};
      input.onblur = () => {if(input.value === '') input.type = 'text'};
    }
    input.placeholder = ' ';
    const spanPlaceholder = this.renderer.createElement("span") as HTMLSpanElement;
    spanPlaceholder.textContent = this.placeholder;
    this.renderer.addClass(spanPlaceholder, "placeholder");

    if (input.required) {
      this.renderer.addClass(spanPlaceholder, "required");
    }
    
    const parent = input.parentNode;
    this.renderer.appendChild(parent, spanPlaceholder);
  }


}
